// Kick off a Stripe Checkout session for a tier.  If the visitor is not
// signed in, we stash the intent in localStorage and route them through
// /login, then the Login page auto-continues to Stripe after signup.
import { CheckoutAPI } from '../api';

const INTENT_KEY = 'shiftnotes_checkout_intent';

export async function startCheckout(tierKey, { user, navigate, toast }) {
  if (!user) {
    localStorage.setItem(INTENT_KEY, tierKey);
    navigate('/login');
    return;
  }
  try {
    const res = await CheckoutAPI.create(tierKey);
    if (res?.url) window.location.href = res.url;
    else toast?.({ title: 'Checkout not available', description: 'Try again in a moment.' });
  } catch (e) {
    toast?.({ title: 'Checkout error', description: e?.response?.data?.detail || e?.message });
  }
}

export function consumePendingIntent() {
  const t = localStorage.getItem(INTENT_KEY);
  if (t) localStorage.removeItem(INTENT_KEY);
  return t;
}
